import { Link } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import WorkShell, { State } from "../components/AppPage";
import { useRecord } from "../utils/appData";
export default function MyApplications() {
  const { currentUser } = useUser();
  const apps = useRecord("JobApplications");
  const jobs = useRecord("Jobs");
  const list = Object.entries(apps.data || {})
    .filter(([, a]) => a?.[currentUser?.uid])
    .map(([id, a]) => ({
      id,
      application: a[currentUser.uid],
      job: jobs.data?.[id],
    }));
  return (
    <WorkShell title="My applications">
      <State
        loading={apps.loading || jobs.loading}
        error={apps.error || jobs.error}
        empty={!list.length}
      >
        Your applications will appear here.
      </State>
      {list.map((a) => (
        <Link
          to={`/jobs/${a.id}`}
          className="zy-card mb-[18px] rounded-[20px] border border-slate-200 bg-white p-[22px] dark:border-[#363e46] dark:bg-[#23272c] [&_h2]:mb-3 [&_h2]:text-[19px] [&_h2]:font-bold [&_h3]:mb-2 [&_h3]:text-[17px] [&_h3]:font-bold block"
          key={a.id}
        >
          <h2>{a.job?.title || "Job unavailable"}</h2>
          <span className="zy-chip mr-[5px] my-[5px] inline-block rounded-[20px] bg-[var(--zylen-page-background,#f6f8fa)] px-2.5 py-[5px] text-xs text-slate-500 dark:text-[#a4b0bc]">
            {a.application.status || "applied"}
          </span>
          <p className="zy-muted text-sm text-slate-500 dark:text-[#a4b0bc]">
            {a.application.coverMessage}
          </p>
        </Link>
      ))}
    </WorkShell>
  );
}
